module.exports = __webpack_public_path__ + "img/vote-success.f7daddba.svg";